import { ALL_TLDs } from '@/src/homepage/shared/constants/constants';
import { TopDestinations } from '@/src/homepage/types';
import {
    topDestination,
    TOP_DESTINATIONS_DOMAIN,
    TOP_DESTINATIONS_LOCALIZED_COUNTRY_NAMES,
} from '@/src/homepage/shared/constants/topDestinations';
import { getTopDestinationsForTld } from '@/src/homepage/shared/utils/getTopDestinationsForTld';

const getCloudfrontPrefix = (ebDomain: string) => {
    const cloudfrontPrefixes: Readonly<Record<string, string>> = Object.freeze({
        evbqa: 'd3156utu65zmy6',
        evbstage: 'd23quzpik3ova8',
        eventbrite: 'd1n9ior3u0lhlo',
    });

    // ebDomain looks like evbqa.com / eventbrite.de / etc
    const ebDomainParts = ebDomain?.split('.') || [];
    const site = ebDomainParts[0];
    return cloudfrontPrefixes[site] || cloudfrontPrefixes.eventbrite;
};

const encodeSpecialCharacters = (slug: string) => {
    return encodeURIComponent(slug).replace(/%/g, '_');
};

export const useTopDestinations = (
    ebDomain: string,
    tld: string,
    topDestinations?: TopDestinations,
): [string | null, topDestination[] | []] => {
    const topDestinationsStaticData = getTopDestinationsForTld(tld as (typeof ALL_TLDs)[number]);
    const topDestinationsData =
        topDestinations && topDestinations.length > 0 ? topDestinations : topDestinationsStaticData;

    const countryDisplayName =
        (TOP_DESTINATIONS_DOMAIN.includes(tld) && TOP_DESTINATIONS_LOCALIZED_COUNTRY_NAMES[tld]) ||
        null;

    const cloudfrontPrefix = getCloudfrontPrefix(ebDomain);
    const topDestinationsWithImage =
        topDestinationsData?.map(
            (top_destination) =>
                ({
                    displayName: top_destination.display_name,
                    locationSlug: top_destination.location_slug,
                    // S3 saves the image file names with underscores instead of percent signs.
                    imageUrl: `https://${cloudfrontPrefix}.cloudfront.net/${encodeSpecialCharacters(
                        top_destination.location_slug,
                    )}.webp`,
                }) as topDestination,
        ) || [];

    return [countryDisplayName, topDestinationsWithImage];
};
